module.exports = __webpack_public_path__ + "img/linea1-1.24b26446.png";